import { ChangeDetectorRef, Component, Inject, OnInit, Optional } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MySpaceService } from 'src/app/views/my-space/my-space.service';
import { MaterialModule } from '../../material.module';
import { AppConfirmService } from '../../services/app-confirm/app-confirm.service';
import { ToastService } from '../../services/toast/toast.service';

@Component({
  selector: 'app-course-archive-viewer',
  templateUrl: './course-archive-viewer.component.html',
  styleUrls: ['./course-archive-viewer.component.scss'],
  standalone: true,
  imports: [FormsModule, TranslateModule, MaterialModule],
})
export class CourseArchiveViewerComponent implements OnInit {
  courses = [];
  displayedCourses = [];
  displayedBlogs = [];
  searchTerm = '';
  loading;
  type;
  blogs = [];
  constructor(
    private mySpaceService: MySpaceService,
    private toast: ToastService,
    private confirmService: AppConfirmService,
    private translate: TranslateService,
    private changeDetectorRef: ChangeDetectorRef,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public bottomSheetData: any
  ) {}

  ngOnInit() {
    this.type = this.dialogData ? this.dialogData.type : this.bottomSheetData.type;
    if (this.type == 'course') {
      this.getCourses();
    } else {
      this.getBlogs();
    }
  }
  getCourseNameAndDesc() {
    this.courses = this.courses.map((course) => {
      if (course.__name) {
        course.actualName = course.__name.editions.find((edition) => edition.language == this.translate.currentLang).content;
      }
      if (course.__description) {
        course.actualDescription = course.__description.editions.find((edition) => edition.language == this.translate.currentLang).content;
      }
      return course;
    });
    this.blogs = this.blogs.map((blog) => {
      if (blog.__name) {
        blog.actualName = blog.__name.editions.find((edition) => edition.language == this.translate.currentLang).content;
      }
      if (blog.__description) {
        blog.actualDescription = blog.__description.editions.find((edition) => edition.language == this.translate.currentLang).content;
      }
      return blog;
    });
    this.filter();
  }

  unArchive(id) {
    if (this.type == 'course') {
      this.confirmService.confirm({ message: this.translate.instant('Confirm.UnarchiveCourse') }).subscribe((res) => {
        if (res) {
          this.loading = true;
          this.mySpaceService.removeFromArchive({ courseID: id }).subscribe(
            (res) => {
              this.getCourses();
            },
            (err) => {
              this.loading = false;
              this.toast.snackbar.open(this.translate.instant('Snackbar.Error'), 'Ok', { duration: 2000 });
            }
          );
        }
      });
    } else {
      this.confirmService.confirm({ message: this.translate.instant('Confirm.UnarchiveBlog') }).subscribe((res) => {
        if (res) {
          this.loading = true;
          this.mySpaceService.removeFromArchive({ blogID: id }).subscribe(
            (res) => {
              this.getBlogs();
            },
            (err) => {
              this.loading = false;
              this.toast.snackbar.open(this.translate.instant('Snackbar.Error'), 'Ok', { duration: 2000 });
            }
          );
        }
      });
    }
  }

  getCourses(): void {
    this.mySpaceService.getArchivedCourses().subscribe(
      (res) => {
        this.courses = res || [];
        this.getCourseNameAndDesc();
        this.displayedCourses = res || [];
        this.loading = false;
        this.changeDetectorRef.markForCheck();
      },
      (err) => {
        console.error(err);
      }
    );
  }

  getBlogs(): void {
    this.mySpaceService.getArchivedBlogs().subscribe(
      (res) => {
        this.blogs = res || [];
        this.getCourseNameAndDesc();
        this.displayedBlogs = res || [];
        this.loading = false;
        this.changeDetectorRef.markForCheck();
      },
      (err) => {
        console.error(err);
      }
    );
  }

  filter() {
    const getCourseName = (course) => {
      return course.actualName || course.name || ' ';
    };
    const getCourseDesc = (course) => {
      return course.actualDescription || course.description || ' ';
    };
    this.displayedCourses = this.courses.filter((course) => {
      return getCourseName(course).toLowerCase().includes(this.searchTerm.toLowerCase()) || getCourseDesc(course).toLowerCase().includes(this.searchTerm.toLowerCase());
    });
    const getBlogName = (blog) => {
      return blog.actualName || blog.name || ' ';
    };
    const getBlogDesc = (blog) => {
      return blog.actualDescription || blog.description || ' ';
    };
    this.displayedBlogs = this.blogs.filter((blog) => {
      return getBlogName(blog).toLowerCase().includes(this.searchTerm.toLowerCase()) || getBlogDesc(blog).toLowerCase().includes(this.searchTerm.toLowerCase());
    });
  }
}
